import { imageOptionsToImgixParams, CONTENTFUL_IMAGES_CDN } from './assets/image.js';

/**
 * @deprecated use `createImageUrl` or `createImageShape` from `./assets/image.js` instead.
 */
const imgix = (img, paramImgx, locale = 'en-US') => {
    let imgURL;
    if (img) {
        let src = `${img}?`;
        if (img.fields && img.fields.file) {
            // Used by Seller Offering
            if (img?.fields?.fullUrl) {
                src = `${img.fields.file.url}?`;
            } else {
                const imageLocaleFilePath = getFieldByLocale(img, 'file', locale);
                src = imageLocaleFilePath.fileName && `${CONTENTFUL_IMAGES_CDN}${img.sys.id}/${locale}/${encodeURIComponent(imageLocaleFilePath.fileName)}?auto=format,compress`;
            }
        }
        imgURL = paramImgx ? src + '&' + paramImgx : src;
    }
    return imgURL;
};

const getFieldByLocale = (entry, field, locale) => {
    return entry.fields[field] && entry.fields[field][locale] ? entry.fields[field][locale] : entry.fields[field];
};

//
/**
 * Converts a Contentful image URL to an S3 URL
 * @param {import('./types').ImageAssetSource} source - The image source from the Header JSON.
 * @param {string} locale - The locale to use for the image.
 * @param {import('./types').ImageSizingOptions} options - Options for URL generation and optimization.
 * @returns {string|null} - The optimized image URL, or null if the source is invalid.
 */
export function imgCtfToS3Url(source, locale = 'en-US', options = {}) {
    if (!source || !source.url) {
        return '';
    }

    try {
        // From https://regex101.com/r/ibVctF/2
        const urlRegex = /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/;

        const match = source.url.match(urlRegex);
        if (!match) {
            throw new Error('Invalid Contentful URL');
        }
        const imagePath = match[5];
        if (!imagePath) {
            throw new Error('Invalid Contentful Image URL');
        }
        const pathSegments = imagePath.split('/');
        if (pathSegments.length < 5) {
            throw new Error('Invalid Contentful Image URL');
        }
        const bucketName = pathSegments[2];
        const imageFilename = source.fileName ?? pathSegments[4];
        if (!bucketName || !imageFilename) {
            throw new Error('Invalid Contentful Image URL');
        }

        const contentfulImgUrl = `${CONTENTFUL_IMAGES_CDN}${bucketName}/${locale}/${encodeURIComponent(imageFilename)}`;
        const s3Url = appendImgixParamsToUrl(contentfulImgUrl, options);
        return s3Url;
    } catch (error) {
        return '';
    }
}

function appendImgixParamsToUrl(url, options) {
    const imgixParams = imageOptionsToImgixParams(options);
    const imgixParamsString = new URLSearchParams(imgixParams).toString();
    return url.includes('?') ? `${url}&${imgixParamsString}` : `${url}?${imgixParamsString}`;
}

export default { imgCtfToS3Url, appendImgixParamsToUrl };
